import Vue from 'vue';
import licenseTransformer from './../../transformers/license';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(licenseTransformer.fetch(errors));
};

export default licenseData => (
  new Promise((resolve, reject) => {
    const data = new FormData();
    Object.keys(licenseData).map((k) => {
      data.append(k, licenseData[k]);
      return null;
    });
    Vue.$http
    .request({
      url: 'license',
      data,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/license/store.js